import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";
import { DATE_UTIL } from "../../../../../utils/dateUtils";


const InformationSection = (props: ScenarioSectionProp) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbShortName")}
                    >
                        <span>{data.short_name_for_scenario}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbPlanningCycleEndDate")}
                    >
                        <span>{DATE_UTIL.convertMonthYearFormat(data.planing_cycle_end_date_month, data.planing_cycle_end_date_year)}</span>

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbBaselIILevel1Category")}
                    >
                        <span>{data.category?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbBaselIILevel2Category")}
                    >
                        <span>{data.category_level_2?.name}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLevel2Detailed")}
                    >
                        <span>{data.category_level_3?.name}</span>
                    </Form.Item>
                </Col>

            </Row>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDescriptionofEvent")}
                    >
                        <span>{data.description_of_event}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbLikelyFailed")}
                    >
                        <span>{data.likely_failed_control_area?.name}</span>
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbDescriptionOfLikely")}
                    >
                        <span>{data.description_of_likely_control_failure}</span>
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default InformationSection;